/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_TitleInputs */

const en_mk_cmp_title = /** @type {(inputs: Mk_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng vs. what you already use`)
};

const id_mk_cmp_title = /** @type {(inputs: Mk_Cmp_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KerjaBareng dibanding yang biasa dipakai`)
};

/**
* | output |
* | --- |
* | "KerjaBareng vs. what you already use" |
*
* @param {Mk_Cmp_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_title = /** @type {((inputs?: Mk_Cmp_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_title(inputs)
	return en_mk_cmp_title(inputs)
});